// extracted by mini-css-extract-plugin
module.exports = {"benefits":"styles_benefits__6Qhv_","pulse":"styles_pulse__96Z98","jump":"styles_jump__07yyp","wiggle":"styles_wiggle__qeoof"};